<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Bulk Send Allthenticate Invite</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <ng-container *ngIf="!loadingSave">
      <p>
        An Allthenticate invite will be sent to each of the
        {{ customerIds.length.toLocaleString() }} selected customer<span
          *ngIf="customerIds.length > 1">s</span>.
      </p>
      <p class="text-muted">
        Customers who have no email address or barcode cannot be invited, and
        will be skipped.
      </p>
    </ng-container>

    <ng-container *ngIf="loadingSave">
      <h4>Loading...</h4>

      <div class="progress">
        <div class="progress-bar" role="progressbar" [style]="{width: getLoadingProgressPercentageStr() + '%'}"
             attr.aria-valuenow="{{ getLoadingProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </ng-container>

    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            [disabled]="!saveButtonEnabled()"
            [class.disabled]="!saveButtonEnabled()"
            (click)="handleSubmit()">
      {{ loadingSave ? 'Loading...' : 'Send Invites' }}
    </button>
  </div>

</ng-container>
